// @flow
import * as React from "react";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import { useEffect, useState } from "react";
import _ from "lodash";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";

type Props = {
  title: string,
  renderButton?: Function,
  withBorder?: boolean,
};

function FadeOnScroll({ children }: { children: React.Node }) {
  const [scrollPosition, setSrollPosition] = useState(0);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setSrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", _.throttle(handleScroll, 200), {
      passive: true,
    });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <Fade in={scrollPosition >= 20}>{children}</Fade>;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    largeTitle: {
      paddingTop: "calc(48px + env(safe-area-inset-top))",
    },
  })
);

function AppHeader({ title, renderButton, withBorder }: Props) {
  const headerTypeStyles = { flexGrow: 1, textAlign: "center" };
  const classes = useStyles();

  return (
    <>
      <FadeOnScroll>
        <AppBar color="inherit">
          <Container disableGutters maxWidth="sm">
            <Toolbar>
              {renderButton != null && <div style={{ width: 48 }} />}
              <Typography variant="h6" style={headerTypeStyles}>
                {title}
              </Typography>
              {renderButton != null ? renderButton() : null}
            </Toolbar>
          </Container>
        </AppBar>
      </FadeOnScroll>
      <Container maxWidth="sm">
        <Typography variant="h4" component="h1" className={classes.largeTitle}>
          <b>{title}</b>
        </Typography>
        <Box mb={1.5} />
        {withBorder && <Divider />}
      </Container>
    </>
  );
}

export default AppHeader;
